import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 15px 16px;
  box-sizing: border-box;
  background: #fff;
`;

export const QnAContainer = styled.div`
  width: 100%;
  max-width: 883px;
  height: 100%;
  display: flex;
`;
